import React from 'react';

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type NeoLeoLinkProps = {
  title: string;
  url: string;
};

const NeoLeoLink: React.FC<NeoLeoLinkProps> = ({ title, url }) => (
  <a key={url} href={url} target='_blank' rel='noreferrer'>
    <div className='flex flex-col'>
      <div className='p-2 bg-white bg-opacity-10 text-reskin-aqua rounded-md flex justify-between items-center'>
        <p className='text-xs font-medium line-clamp-1 mr-1'>{title}</p>
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='text-sm' />
      </div>
    </div>
  </a>
);

export default NeoLeoLink;
